import React from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { Link } from "react-router-dom";
import LocationCityOutlinedIcon from "@mui/icons-material/LocationCityOutlined";
import DeletedLabel from "components/DeletedLabel";
import statusActive from "assets/images/city/statusActive.svg";
import statusInactive from "assets/images/city/statusInactive.svg";
import DeleteIcon from "@mui/icons-material/Delete";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";
import CreditCardIcon from "@mui/icons-material/CreditCard";

function CityName({ name }) {
  return (
    <SoftBox display="flex" minWidth="180px" alignItems="center" px={1} py={0.5} gap={1.5}>
      <SoftBox
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          width: 32,
          height: 32,
          borderRadius: "100%",
          backgroundColor: "#E2E2E2",
          p: 0,
        }}
      >
        <LocationCityOutlinedIcon sx={{ height: 20, width: 20, color: "#555F73" }} />
      </SoftBox>
      <SoftTypography
        sx={{ fontSize: 14, color: "#1A1C1C", textTransform: "capitalize", fontWeight: 500, }}
        fontWeight="normal"
      >
        {name}
      </SoftTypography>
    </SoftBox>
  );
}

export const columns = [
  { name: "city", align: "left" },
  { name: "state / province", align: "left" },
  { name: "country", align: "left" },
  { name: "users", align: "left" },
  { name: "status", align: "center" },
  { name: "subscription required", align: "center" },
  { name: "action", align: "left" },
];

function Rows(data, setDialogue, returnPath) {
  return {
    linkPath: `/city-details/${data?._id}`,
    returnPath,
    noLinkCells: ["action", "status"],
    city: <CityName name={data?.city} />,

    "state / province": (
      <SoftBox minWidth="140px" display="flex" alignItems="center" justifyContent="start" px={1}>
        <SoftBox height="30px" />
        <SoftTypography
          sx={{ fontSize: 14, color: "black.main", textTransform: "capitalize" }}
          fontWeight="normal"
        >
          {data?.state || "—"}
        </SoftTypography>
      </SoftBox>
    ),

    country: (
      <SoftBox minWidth="120px" display="flex" alignItems="center" justifyContent="start" px={1}>
        <SoftBox height="30px" />
        <SoftTypography
          sx={{ fontSize: 14, color: "black.main", textTransform: "capitalize" }}
          fontWeight="normal"
        >
          {data?.country_abbr || data?.country || "—"}
        </SoftTypography>
      </SoftBox>
    ),

    users: (
      <SoftBox display="flex" alignItems="center" justifyContent="start" px={1}>
        <SoftBox height="30px" />
        <SoftTypography
          sx={{ fontSize: 14, color: "black.main", textTransform: "capitalize" }}
          fontWeight="normal"
        >
          {data?.users || 0}
        </SoftTypography>
      </SoftBox>
    ),

    status: (
      <SoftBox
        minWidth="100px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        onClick={(event) => {
          event.stopPropagation();
          !data?.is_deleted &&
            setDialogue({
              type: "changeCityStatus",
              isOpen: true,
              action: "",
              cityID: data?._id,
            });
        }}
        sx={{ cursor: data?.is_deleted ? "default" : "pointer" }}
      >
        {data?.is_deleted ? (
          <SoftBox display="flex" alignItems="center" justifyContent="center" px={1}>
            ---
          </SoftBox>
        ) : (
          <SoftBox
            component="img"
            src={data?.is_active ? statusActive : statusInactive}
            alt={data?.is_active ? "Active" : "Inactive"}
            sx={{
              width: data?.is_active ? 30 : 31,
              height: 20,
              display: "block",
            }}
          />
        )}
      </SoftBox>
    ),

    "subscription required": (
      <SoftBox
        minWidth="100px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        onClick={(event) => {
          event.stopPropagation();
          !data?.is_deleted &&
            setDialogue({
              type: "changeSubscriptionRequired",
              isOpen: true,
              action: "",
              cityID: data?._id,
              name: data?.city,
              subscription_required: data?.subscription_required,
            });
        }}
        sx={{ cursor: data?.is_deleted ? "default" : "pointer" }}
      >
        {data?.is_deleted ? (
          <SoftBox display="flex" alignItems="center" justifyContent="center" px={1}>
            ---
          </SoftBox>
        ) : (
          <SoftBox
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={0.5}
            px={1}
            py={0.5}
            borderRadius="xxl"
            sx={{
              backgroundColor: "purple.light",
            }}
          >
            <SoftBox
              component="img"
              src={data?.subscription_required ? statusActive : statusInactive}
              alt={data?.subscription_required ? "Active" : "Inactive"}
              sx={{
                width: data?.subscription_required ? 30 : 31,
                height: 20,
                display: "block",
              }}
            />
            {/* <CreditCardIcon sx={{ height: 16, width: 16, color: "purple.main" }} />
            <SoftTypography
              sx={{ fontSize: 12, color: "purple.main", fontWeight: "normal" }}
            >
              {data?.subscription_required ? "Yes" : "No"}
            </SoftTypography> */}
          </SoftBox>
        )}
      </SoftBox>
    ),

    action: (
      <>
        {data?.is_deleted ? (
          <SoftBox display="flex" alignItems="center" justifyContent="center" px={1}>
            <SoftBox height="30px" />
            <DeletedLabel />
          </SoftBox>
        ) : (
          <SoftBox display="flex" alignItems="start" justifyContent="start" gap={1} px={1}>
            <SoftBox
              component={Link}
              to={`/edit-city/${data?._id}`}
              state={returnPath ? { from: returnPath } : undefined}
              borderRadius="xxl"
              display="flex"
              sx={{
                backgroundColor: "light.main",
                width: "80px",
                py: 0.8,
                gap: 1,
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              <NoteAltOutlinedIcon sx={{ height: 20, width: 20, color: "yellow.main" }} />
              <SoftTypography
                fontWeight="normal"
                sx={{ color: "yellow.main", fontSize: 13, textTransform: "capitalize" }}
              >
                Edit
              </SoftTypography>
            </SoftBox>

            <SoftBox
              onClick={(event) => {
                event.stopPropagation();
                setDialogue({
                  type: "deleteCity",
                  isOpen: true,
                  action: "",
                  cityID: data?._id,
                });
              }}
              borderRadius="xxl"
              display="flex"
              sx={{
                backgroundColor: "red.light",
                width: "80px",
                py: 0.8,
                gap: 1,
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              <DeleteIcon sx={{ height: 20, width: 20, color: "red.main" }} />
              <SoftTypography
                fontWeight="normal"
                sx={{ color: "red.main", fontSize: 13, textTransform: "capitalize" }}
              >
                Delete
              </SoftTypography>
            </SoftBox>
          </SoftBox>
        )}
      </>
    ),
  };
}

export default Rows;
